// extracted by mini-css-extract-plugin
export default {"scrollBarDirection":"styles_scrollBarDirection__VIYlQ","collection":"styles_collection__hNP1S"};